import { render, staticRenderFns } from "./student_certification.vue?vue&type=template&id=1e9b3fd2&scoped=true"
import script from "./student_certification.vue?vue&type=script&lang=js"
export * from "./student_certification.vue?vue&type=script&lang=js"
import style0 from "./student_certification.vue?vue&type=style&index=0&id=1e9b3fd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9b3fd2",
  null
  
)

export default component.exports